module.exports = __webpack_public_path__ + "27da121bf524fd2e2b3bf8da69d2bb63.svg";